<template>
  <div class="showcase">
    <div class="card" v-for="(item, index) in items" :key="index">
      <div class="bg" :style="{ backgroundImage: `url(${item.image})` }"></div>
      <div class="mask"></div>
      <div class="content">
        <div class="cat">{{ item.category }}</div>
        <div class="en">{{ item.translate }}</div>
        <div class="desc">{{ item.selected.dese }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { oss } from "@/utils/oss";
import { ref } from "vue";
const items = ref([
  {
    category: "启愉鱼缸",
    translate: "INSPIRER fish tank",
    image: oss("ppt/showcase-reef.jpg"),
    selected: {
      dese: "启愉智能鱼缸搭载 AI 智能养鱼系统，水质实时监测、一键智能换水、底滤自清洁，让新手零基础也能轻松养好鱼。",
    },
  },
  {
    category: "启愉鱼池",
    translate: "INSPIRER fish pond",
    image: oss("customization/鱼池.png"),
    selected: {
      dese: "启愉智慧鱼池面向别墅、会所等场景，提供定制化方案与智能养护系统，实现实时监测、智能换水与自清洁等一键功能。",
    },
  },
  {
    category: "启愉配件",
    translate: "INSPIRER accessories",
    image: oss("home/测试3.jpg"),
    selected: {
      dese: "智控照明、无级调控水泵、自适应喂食器、双温控加热棒等高性价比智慧配件，与启愉智能鱼缸完美搭配，全面赋能轻松养鱼。",
    },
  },
  {
    category: "公司实景",
    translate: "Company actual situation",
    image: oss("home/测试4.jpg"),
    selected: {
      dese: "启愉智能，以研发制造 AI 智能养鱼系统为主的科技创新型企业，致力实现水族 / 水产养护的科学、轻松、共赢的未来。",
    },
  },
]);
</script>

<style scoped lang="scss">
.showcase {
  width: 100%;
  height: 760px;
  margin: 0 auto;
  padding: 0 48px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1.45fr 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 24px;

  .card {
    position: relative;
    overflow: hidden;
    border-radius: 0;
    cursor: pointer;
    box-shadow: 0 8px 28px rgba(12, 99, 181, 0.1);

    // 左侧大图：跨满整列三行
    &:first-child {
      grid-row: 1 / 4;
    }

    // 右侧三张小卡：更紧凑
    &:not(:first-child) {
      .content {
        padding: 20px 26px;
        &::before {
          top: 24px;
          height: 24px;
        }
        .cat {
          font-size: 22px;
        }
        .desc {
          font-size: 13px;
          line-height: 22px;
        }
      }
    }

    .bg {
      position: absolute;
      inset: 0;
      background-size: cover;
      background-position: center;
      transition: transform 0.6s ease;
    }
    // 默认：仅标题处一点点渐变，图片基本清晰
    .mask {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(9, 36, 64, 0) 54%,
        rgba(9, 36, 64, 0.38) 82%,
        rgba(9, 36, 64, 0.64) 100%
      );
    }
    // 小卡更矮：渐变范围略大一点
    &:not(:first-child) .mask {
      background: linear-gradient(
        180deg,
        rgba(9, 36, 64, 0) 48%,
        rgba(9, 36, 64, 0.4) 78%,
        rgba(9, 36, 64, 0.68) 100%
      );
    }
    // 悬停加深层：展开描述时压暗背景，保证可读（用 opacity 平滑过渡）
    &::after {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(
        180deg,
        rgba(9, 36, 64, 0) 0%,
        rgba(9, 36, 64, 0.45) 50%,
        rgba(9, 36, 64, 0.78) 100%
      );
      opacity: 0;
      transition: opacity 0.45s ease;
    }
    .content {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      padding: 30px 36px;
      color: #ffffff;
      text-align: left;
      // 左侧品牌色竖条
      &::before {
        content: "";
        position: absolute;
        left: 36px;
        top: 34px;
        width: 4px;
        height: 30px;
        background: $accent;
        transition: height 0.3s;
      }
      .cat {
        font-family: $font-title;
        font-size: 28px;
        font-weight: bold;
        line-height: 1.2;
        padding-left: 16px;
      }
      .en {
        font-family: $font-number;
        font-size: 14px;
        letter-spacing: 0.5px;
        color: rgba(255, 255, 255, 0.7);
        margin-top: 4px;
        padding-left: 16px;
      }
      // 默认仅显示标题，hover 时展开描述
      .desc {
        font-size: 15px;
        line-height: 26px;
        color: #e6e9ee;
        padding-left: 16px;
        max-width: 480px;
        margin-top: 0;
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        transition: max-height 0.45s ease, opacity 0.4s ease, margin-top 0.45s ease;
      }
    }

    &:hover {
      .bg {
        transform: scale(1.06);
      }
      // 压暗背景，展开描述
      &::after {
        opacity: 1;
      }
      .content .desc {
        max-height: 200px;
        opacity: 1;
        margin-top: 14px;
      }
    }
  }
}
</style>
